import { configureStore as configureStoreRTK } from '@reduxjs/toolkit'
import { listenerMiddleware } from '@mfs/client/listings-client/store/listenerMiddleware'

function configureStore(reducers, initialState) {
  return configureStoreRTK({
    reducer: reducers,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: {
          ignoredPaths: [
            // Ignoring 'airSearchRequestModel' due to mutations done by class AirSearchRequestModel and it's methods (see airSearchRequestModel.js).
            // Plan to transition to redux actions for mutating airSearchRequestModel in the future.
            // This will help with SSR streaming as well , no need to maintain singleton of AirSearchRequestModel.
            // After removing class AirSearchRequestModel and replacing with redux actions, remove this line.
            'airSearchRequestModel',
          ],
        },
        serializableCheck: false,
      }).prepend(listenerMiddleware.middleware),
  })
}

export { configureStore }
